import LocalizedStrings from 'react-localization';

let strings = new LocalizedStrings({

    en: {
        plan:"Read our plan (PDF)",
        planLink:"https://site-cbc.radio-canada.ca/documents/impact-and-accountability/diversity-inclusion/plan-2021-2023/progress_in_progress_2022-2025_edi_plan.pdf",
        summary:"See the summary (PDF)",
        summaryLink:"https://site-cbc.radio-canada.ca/documents/impact-and-accountability/diversity-inclusion/plan-2021-2023/Summary_2022-2025_EDI_plan.pdf",
        report:"Read our progress report",
        reportLink:"https://cbc.radio-canada.ca/en/impact-and-accountability/diversity-and-inclusion/initiatives/update-june2021",
        alt:"Patrick Masbourian, host of the daily radio morning show Tout un matin airing on Radio-Canada.",
        legend:"Patrick Masbourian, host of Tout un matin on ICI PREMIÈRE"
    },
    fr: {
        plan:"Consulter notre plan (PDF)",
        planLink:"https://site-cbc.radio-canada.ca/documents/impact-and-accountability/diversity-inclusion/plan-2021-2023/cap_sur_le_succes_plan_edi_2022-2025.pdf",
        summary:"Consulter le sommaire du plan (PDF)",
        summaryLink:"https://site-cbc.radio-canada.ca/documents/impact-and-accountability/diversity-inclusion/plan-2021-2023/Resume_Plan_EDI_2022-2025.pdf",
        report:"Consulter le compte rendu de nos progrès",
        reportLink:"https://cbc.radio-canada.ca/fr/transparence-et-engagement/diversite-et-inclusion/initiatives/mise-a-jour-juin-2021",
        alt:"Patrick Masbourian, host of the daily radio morning show Tout un matin airing on Radio-Canada.",
        legend:"Patrick Masbourian, animateur de Tout un matin sur ICI PREMIÈRE"
    }
});

export default strings;